import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllLegalMatterStatusAutocomplete } from './useLegalMatterStatusAutocomplete';

export const useCreateLegalMatterStatusMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.ILegalMatterStatus) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			status,
			impersonationContext,
		}: {
			status: Api.ILegalMatterStatus;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.ILegalMatterStatus>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'legalMatter/status',
				}),
				'POST',
				status
			);
		},
		onError,
		onSuccess: data => {
			invalidateAllLegalMatterStatusAutocomplete();
			onSuccess?.(data);
		},
	});
};
